import React, { useEffect, useState } from "react";
import { useTable, usePagination } from "react-table";
import { connect } from "react-redux";
import { useTranslation } from "react-i18next";
import { getLeaderboardUserEventHistory } from "@/services/program/getLeaderboardUserEvents";
import ReactTablePagination from "@/shared/components/table/components/ReactTablePagination";
import { LEADERBOARD_AWARDS_COLUMNS } from "@/containers/Manager/Home/components/Column";

const PAGE_SIZE = 10;

const LeaderboardAwardHistoryTable = ({ participant, leaderboardId, program, organization }) => {

  const { t } = useTranslation();
  const [data, setData] = useState([]);
  const [count, setCount] = useState(0);
  let history_columns = [
    ...LEADERBOARD_AWARDS_COLUMNS
  ];

  const columns = React.useMemo(() => history_columns, []);

  const tableInstance = useTable({
    columns,
    data: React.useMemo(() => data ? data : [], [data]),
    initialState: {
      pageIndex: 0,
      pageSize: 10,
    },
    manualPagination: true,
    pageCount: Math.ceil(count / PAGE_SIZE),
    autoResetSortBy: false,
    autoResetExpanded: false,
    autoResetPage: false,
  }, usePagination);

  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    rows,
    prepareRow,
    page,
    pageCount,
    pageOptions,
    gotoPage,
    previousPage,
    canPreviousPage,
    nextPage,
    canNextPage,
    setPageSize,
    selectedFlatRows,
    state: { pageIndex, pageSize },
  } = tableInstance;

  useEffect(() => {
    if (organization?.id && program?.id && participant?.user_id && leaderboardId) {
      getLeaderboardUserEventHistory(organization.id, program.id, participant.user_id, leaderboardId, pageIndex, 10)
        .then(data => {
          data.results.map(row => row.amount)
          setData(data.results);
          setCount(data.count);
        })
        .catch(error => {
          console.log(error.response);
        })
    }
  }, [pageIndex, participant]);


  if (!data) return t("loading");

  return (
    <>
      <div className="award-history-table__wrap">
        <table className="award-history-table table--stack-mobile" {...getTableProps()}>
          <thead className="award-history-table__head">
            {headerGroups.map((headerGroup) => (
              <tr {...headerGroup.getHeaderGroupProps()}>
                {headerGroup.headers.map((column) => (
                  <th className="award-history-table__th" {...column.getHeaderProps()}>
                    {column.render("Header")}
                  </th>
                ))}
              </tr>
            ))}
          </thead>
          <tbody className="award-history-table__body" {...getTableBodyProps()}>
            {rows.length === 0 ? (
              <tr>
                <td className="award-history-table__empty" colSpan={history_columns.length}>
                  No award history found
                </td>
              </tr>
            ) : (
              rows.map((row) => {
                prepareRow(row);
                return (
                  <tr className="award-history-table__row" {...row.getRowProps()}>
                    {row.cells.map((cell) => (
                      <td
                        className="award-history-table__td"
                        {...cell.getCellProps()}
                        data-label={typeof cell.column.Header === "string" ? cell.column.Header : ""}
                      >
                        {cell.render("Cell")}
                      </td>
                    ))}
                  </tr>
                );
              })
            )}
          </tbody>
        </table>
      </div>

      {rows.length > 0 && (
        <div className="award-history-table__pagination">
          <ReactTablePagination
            page={page}
            gotoPage={gotoPage}
            previousPage={previousPage}
            nextPage={nextPage}
            canPreviousPage={canPreviousPage}
            canNextPage={canNextPage}
            pageOptions={pageOptions}
            pageSize={pageSize}
            pageIndex={pageIndex}
            pageCount={pageCount}
            setPageSize={setPageSize}
            manualPageSize={[]}
            dataLength={count}
          />
        </div>
      )}
    </>
  );
};

const mapStateToProps = (state) => {
  return {
    program: state.program,
    organization: state.organization,
  };
};

export default connect(mapStateToProps)(LeaderboardAwardHistoryTable);
